import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/deal`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

export interface DealHistoryItem {
  changed_fields: string[];
  changed_values: Record<string, { old: string; new: string }>;
  modified_at: string;
  modified_by: string;
}

export interface DealHistoryResponse {
  deal_created_at: string;
  deal_history: DealHistoryItem[];
}

export const fetchDealHistory = async (
  dealId: string
): Promise<DealHistoryResponse> => {
  try {
    const res = await axios.get(`${BASE_URL}/history/${dealId}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch deal history");
    throw error;
  }
};
export type DealStatusChange = {
  from: string;
  to: string;
  changedAt: string;
  changedBy: string;
};
  const normalizeStatus = (raw: string): string =>
  raw?.includes(".") ? raw.split(".").pop() || raw : raw;

// Extract function
export const extractStatusChanges = (
  history: DealHistoryResponse
): DealStatusChange[] => {
  const { deal_history } = history;

  const changes: DealStatusChange[] = [];

  for (const item of deal_history) {
    if (
      item.changed_fields.includes("status") &&
      item.changed_values.status
    ) {
      const { old, new: newStatus } = item.changed_values.status;

      changes.push({
        from: normalizeStatus(old),
        to: normalizeStatus(newStatus),
        changedAt: item.modified_at,
        changedBy: item.modified_by,
      });
    }
  }

  return changes.sort(
    (a, b) => new Date(a.changedAt).getTime() - new Date(b.changedAt).getTime()
  );
};

